export var AddressType;
(function (AddressType) {
    AddressType[AddressType["All"] = 1] = "All";
    AddressType[AddressType["RegisteredAddress"] = 2] = "RegisteredAddress";
    AddressType[AddressType["ContactAddress"] = 3] = "ContactAddress";
})(AddressType || (AddressType = {}));
